// test1933
(1933 && 0);
